import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Typography,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Divider,
    Chip,
    Grid,
    useTheme,
    useMediaQuery
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import RestaurantInfo from 'components/RestaurantInfo/RestaurantInfo';
import { useSelector } from 'react-redux';
import OrderSummary from 'components/OrderSummary/OrderSummary';
import SummaryCard from 'components/SummaryCard/SummaryCard';
import CustomTypography from 'components/Fileds/CustomTypography';
import CustomSelect from 'components/Fileds/CustomSelect';
import CustomButton from 'components/Fileds/CustomButton';

const TimeDisplay = React.memo(function TimeDisplay() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
  const timeStr = now.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

  return (
    <Box className="d-flex align-items-start" sx={{ flexDirection: 'column' }}>
      <CustomTypography variant="h5" label="TODAY" sx={{ fontSize: 20, fontWeight: 700 }} />
      <CustomTypography variant="body2" label={`${dateStr} | ${timeStr}`} />
    </Box>
  );
});

export default function ServeSummary({
    chefs = [],                 // [{ id, name }]
    selectedChef = 'all',       // current filter
    onChefChange = () => { },
    serveSummary,
    onFetch = () => { },
    orderLoading,
    isLoading = false
}) {
    const userData = useSelector((state) => state?.posData);

    const theme = useTheme()
    const isSmall = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <Box className='d-flex align-items-center' sx={{ gap: 3, mb: 3, }}>
            {/* Today + Fetch */}
            <Box className='d-flex align-items-center' sx={{ gap: 2 }}>
                 <TimeDisplay />
                <CustomButton
                    fullWidth
                    sx={{ borderRadius: "10px", width: "120px" }}
                    onClick={onFetch}
                    loading={orderLoading}
                >
                    Fetch New
                </CustomButton>
            </Box>

            <Divider orientation="vertical" flexItem sx={{ borderColor: `#4D4D4D !important` }} />

            <Grid className='order-summary-container' container sx={{ ml: 0, flex: 1, gap: 3, alignItems: 'center' }}>
                <Box className='d-flex align-items-start' sx={{ flexDirection: 'column' }}>
                    <CustomTypography
                        label="Filter Orders by Stations"
                        sx={{ fontSize: '12px', fontWeight: 600, color: theme.palette.drawermenuitem.main }}
                    />
                    <CustomSelect
                        name="chef"
                        value={selectedChef}
                        options={chefs}
                        onChange={e => onChefChange(e.target.value)}
                        sx={{ width: '180px', borderRadius: '10px',backgroundColor:'#fff', fontSize:'14px', lineHeight:'1.5' }}
                    />
                </Box>
                {serveSummary?.map((item) => (
                    <Grid item xs={6} sm={6} md={3.5} key={item.id}>
                        <SummaryCard
                            item={item}
                            isSmall={isSmall}
                            theme={theme}
                            height="60px"
                            isLoading={isLoading}
                        />
                    </Grid>
                ))}
            </Grid>

            {/* Restaurant */}
            {/* <Box sx={{ textAlign: 'right' }}>
                <RestaurantInfo name={userData?.vendor?.name} description={userData?.vendor?.tagline} />
            </Box> */}
        </Box>
    );
}
